export default "__VITE_ASSET__EIkkASZ1__"